import script from "./double.vue?vue&type=script&setup=true&lang=js"
export * from "./double.vue?vue&type=script&setup=true&lang=js"

import "./double.vue?vue&type=style&index=0&id=0232744e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0232744e"]])

export default __exports__